var styleDataHash = "e0281cb6";
const injectCss = (() => {
  var css = `.Tzhaw,.glob_fontElementMap,.uKpvq,button{font-family:var(--ricos-font-family,unset)}.lXW3k{display:flex}._4DjYc:hover,.jlTVk{border-radius:var(--ricos-native-whitebox-border-radius,0);box-shadow:0 0 0 1.5px #116dff;cursor:default}.iIPzA .jlTVk,[data-hook^=figure-][data-cropping] .jlTVk{box-shadow:none!important}.iIPzA :is([data-resize-handle],[data-hook=image-corner-radius-handle],[data-hook=image-corner-radius-label]){display:none!important}.Yi87g{cursor:move;display:block;height:100%;left:0;position:absolute;top:0;width:100%}.Yi87g.YFosz{pointer-events:none}._4hsuN ::selection{background:transparent}.Dfymf{display:none}.Tzhaw{position:relative}._0Sqn2{max-width:100%}.H5izM{color:#333;text-decoration:none}.d39YD{display:block}.yRCDO{position:relative}.obpdN{margin-left:-20px;margin-right:-20px;overflow-x:auto;overflow-y:hidden}.obpdN.Ifuuc::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}.obpdN.BlxZV::-webkit-scrollbar-thumb{background-color:transparent}.tY5P4{max-width:max-content!important;min-width:100%}.obpdN::-webkit-scrollbar{-webkit-appearance:none}.obpdN::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}.obpdN::-webkit-scrollbar:horizontal{height:10px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "fontElementMap": "uKpvq",
  "pluginContainer": "Tzhaw",
  "flex": "lXW3k",
  "isFocusable": "_4DjYc",
  "hasFocus": "jlTVk",
  "dragImageView": "iIPzA",
  "overlay": "Yi87g",
  "noPointerEventsOnFocus": "YFosz",
  "hideTextSelection": "_4hsuN",
  "hidden": "Dfymf",
  "pluginContainerMobile": "_0Sqn2",
  "isImage": "H5izM",
  "anchor": "d39YD",
  "horizontalScrollbarWrapper": "yRCDO",
  "pluginWithHorizontalScrollbar": "obpdN",
  "show": "Ifuuc",
  "hide": "BlxZV",
  "horizontalScrollbar": "tY5P4"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
